import { Injectable } from '@angular/core';
import { ITranslationService } from './itranslation.service';
import { TranslateService } from '@ngx-translate/core';
import { UtilService } from '../util/util.service';
//import moment from 'moment-es6';
import { MomentService } from '../moment/moment.service';
import { NameValue } from '../model/name-value.model';

@Injectable()
export class TranslationService implements ITranslationService {
  private _momentService: MomentService;
  public _translateService: TranslateService;
  public _utilService: UtilService;

  public constructor(translationService: TranslateService, utilService: UtilService, momentService: MomentService) {
    this._translateService = translationService;
    this._utilService = utilService;
    this._momentService = momentService;
  }

  public get = (key: string): Promise<string> => {
    return this._translateService.get(key).toPromise();
  };

  public getAsObject(key: string): Promise<object> {
    return this._translateService.get(key).toPromise();
  }

  public getTitlecase(key: string): Promise<string> {
    return this._translateService
      .get(key)
      .toPromise()
      .then((data: string) => {
        let translation = this._utilService.toTitleCase(data);
        return Promise.resolve(translation);
      });
  }

  public getCapitalizeFirstCharacter(key: string): Promise<string> {
    return this._translateService
      .get(key)
      .toPromise()
      .then((data: string) => {
        let translation = this._utilService.toCapitalizedFirstCharacter(data);
        return Promise.resolve(translation);
      });
  }

  public getInstant = (key: string, interpolateParams?: Object): string => {
    let numOfTrys: number = 0;
    let instantTranslation: string = '';
    do {
      try {
        numOfTrys = numOfTrys + 1;
        instantTranslation = this._translateService.instant(key, interpolateParams);
        //if no error thrown set to 5 to exit do
        numOfTrys = 5;
      } catch (err) {
        //try again as the lang file may not finished getting parsed
        instantTranslation = key;
      }
    } while (numOfTrys < 5);

    return instantTranslation;
  };

  public getInstantTitlecase(key: string): string {
    return this._utilService.toTitleCase(this.getInstant(key));
  }

  public getInstantCapitalizeFirstCharacter = (key: string): string => {
    return this._utilService.toCapitalizedFirstCharacter(this.getInstant(key));
  };

  public getMonths = (): string[] => {
    //this._momentService.getMoment().locale(this._translateService.currentLang);
    //return this._momentService.getMoment().months();

    let months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    return months;
  };

  public getMonthName = (monthIndex: number): string => {
    //this._momentService.getMoment().locale(this._translateService.currentLang);
    //return this._momentService.getMoment().months(monthIndex);
    let monthName = '';
    switch (monthIndex) {
      case 1:
        monthName = 'January';
        break;
      case 2:
        monthName = 'February';
        break;
      case 3:
        monthName = 'March';
        break;
      case 4:
        monthName = 'April';
        break;
      case 5:
        monthName = 'May';
        break;
      case 6:
        monthName = 'June';
        break;
      case 7:
        monthName = 'July';
        break;
      case 8:
        monthName = 'August';
        break;
      case 9:
        monthName = 'September';
        break;
      case 10:
        monthName = 'October';
        break;
      case 11:
        monthName = 'November';
        break;
      case 12:
        monthName = 'December';
        break;
      default:
        break;
    }

    return monthName;
  };
}
